<template>
  <div class="edit-machine-container edit-machine-com">
    <div class="admin-header-container">
      <div class="admin-header">
        <h1 class="title">{{ $t('machine') + ': ' + machine.brand + " " + machine.name }} </h1>
        <div>
          <div class="img-container">
            <img width="90" :src="fit20.storageBaseUrl + '/machine/test.svg'" />
          </div>
          <div class="btn-container">
            <span id="cancel_machine" class="fit20-btn cancel-btn-disable" @click="cancelEditing">{{ $t('cancel')
              }}</span>
            <span id="save_machine" class="fit20-btn save-btn-disable" @click="saveMachine">{{ $t('save') }}</span>
          </div>
        </div>
      </div>
    </div>
    <h2 class="item">{{ $t('general-info') }}</h2>
    <main class="tab-content">
      <form class="form-container admin-machine-tab-pane" id="admin_machine_info">
        <div class="">
          <label class="">{{ $t('brand') }}</label>
          <select type="text" class="form-control" v-model="machine.brand">
            <option value=""></option>
            <option v-for="brand in fit20.brands" :key="brand" :value="$t(brand)">{{ $t(brand) }}</option>
          </select>
        </div>
        <div class="">
          <label class="">{{ $t('name') }}</label>
          <input type="text" class="form-control" v-model="machine.name" />
        </div>
        <div class="">
          <label class="">{{ $t('resistance-unit') }}</label>
          <select type="text" class="form-control" v-model="machine.unit">
            <option value="KG">kg</option>
            <option value="LBS">lbs</option>
          </select>
        </div>
        <div class="">
          <label class="">{{ $t('possible-resistance') }}</label>
          <textarea placeholder="2.5 5 7.5 10 15 20 25" class="form-control" v-model="machine.weights">
          </textarea>
        </div>
        <div class="">
          <label class="">{{ $t('start-resistance') }}</label>
          <input type="number" class="form-control" v-model="machine.defaultWeight"
            @input="convertToNumber('defaultWeight')" />
        </div>
        <div class="">
          <label class="">{{ $t('own-resistance') }} (x 100%)</label>
          <input type="number" class="form-control" v-model="machine.addPersonWeight"
            @input="convertToNumber('addPersonWeight')" />
        </div>
        <div>
          <h2>{{ $t('setting') }}</h2>
        </div>
        <div class="fade">
          <label for="" class="">{{ $t('active') }}</label>
          <input type="test" />
        </div>
        <!-- just to correct the display -->
        <div class="">
          <label class="">{{ $t('machine-setting') }}</label>
        </div>
        <div class="">
          <label class="">{{ $t('possible-values') }}</label>
        </div>
        <div class="machine-setting" v-for="(partSetting, i) in machine.adjustable ">
          <select class="form-control" v-model="partSetting.name">
            <option></option>
            <option v-for="part in generateCustomNumbers(2, 44)" :key="part" :value="part">{{ $t(part) }} </option>
          </select>
          <input type="text" class="form-control" v-model="partSetting.values" />
        </div>
        <div @click="addSetting">{{ $t('add') }}</div>
      </form>
    </main>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
// import AddRemoveItem from './AddRemoveItem.vue'
export default {
  name: 'Machine',
  // components: {
  //   AddRemoveItem
  // },
  props: ["selectTab", "admin_fit20", "fit20"],
  data() {
    return {
      brands: ["test", "test2", "test3"],
      machine: {
        adjustable: [{
          name: "",
          values: ""
        }],
        adjustableValues: []
      },
      machines: [],
      originalMachine: {},
      updated: false,
    };
  },
  methods: {
    saveMachine: async function () {
      let settings;
      let newMachineSettings = this.machine.adjustable.filter(fields => {
        if ((!fields.name.trim() && fields.values.trim()) || (fields.name.trim() && !fields.values.trim())) {
          settings = true;
        }
        if ((fields.name.trim() && fields.values.trim())) {
          return fields;
        }
      })
      // the translation should continue here..............................................
      if (settings) {
        alert(this.$t('edit-machine-err'))
      } else
        if (isEqual(this.machine, this.originalMachine)) {
          alert(this.$t('general-no-changes'))
        } else if (!this.machine.name) {
          alert(this.$t('required-field').replace('{field}', this.$t('name')))
        } else {
          if (this.machine.id == "new_machine") {
            this.machine.id = false;
          }
          this.machine.adjustable = newMachineSettings
          // console.log(this.machine.adjustable);
          // console.log("call");
          let updateMachine = await fetch(this.fit20.baseUrl + "/api/machines/mohammad_test@test.com?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.machine),
          });
          let updatedMachine = await updateMachine.json();
          this.admin_fit20.machine = updatedMachine;
          if (!this.machine.id) {
            this.admin_fit20.machines = [...this.admin_fit20.machines, updatedMachine];
          } else {
            this.admin_fit20.machines = [...this.admin_fit20.machines.map(obj => (obj.id == updatedMachine.id ? updatedMachine : obj))];
          }
          this.updated = true;
        }
    },
    cancelEditing: function () {
      if (!isEqual(this.machine, this.originalMachine)) {
        this.admin_fit20.machine =
          JSON.parse(JSON.stringify(this.originalMachine));
        this.updated = true;
      }
    },
    generateCustomNumbers: function (start, end) {
      const customNumbers = [];
      for (let i = start; i <= end; i++) {
        if (i % 2 == 0) {
          let stringNum = i.toString();
          if (stringNum.length > 1) {
            customNumbers.push("^00" + stringNum);
          } else {
            customNumbers.push("^000" + stringNum);
          }
        }
      }
      return customNumbers;
    },
    convertToNumber: function (field) {
      this.machine[field] = Number(this.machine[field]);
    },
    addSetting: function () {
      this.machine.adjustable.push({
        name: "",
        values: ""
      })
    }
  },
  watch: {
    'admin_fit20.machine': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal && newVal.id && (!this.machine.id || this.machine.id != newVal.id || this.updated)) {
          this.machine = JSON.parse(JSON.stringify(newVal));
          this.originalMachine = JSON.parse(JSON.stringify(newVal));
          this.updated = false;
        }
      }
    },
    machine: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (isEqual(newVal, this.originalMachine)) {
          $('#cancel_machine').removeClass("cancel-btn-active");
          $('#save_machine').removeClass("save-btn-active");
        } else {
          if (!$('#cancel_machine').hasClass('cancel-btn-active')) {
            $('#cancel_machine').addClass("cancel-btn-active");
            $('#save_machine').addClass("save-btn-active");
          }
        }
      }
    },
  }
};
</script>

<style>
.edit-machine-com.edit-machine-container {
  width: 100%;
  height: calc(100vh - 90px);
  /* Adjust as needed */
  overflow: auto;
}

.edit-machine-com .form-container {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-machine-com .form-container div:not(.machine-setting) {
  width: calc(100% / 2 - 30px);
}

.edit-machine-com .form-container label {
  display: block;
}

.edit-machine-com .machine-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-machine-com .users-col {
  width: calc(100% / 2 - 20px);
}

.edit-machine-com .machine-col {
  max-width: 600px;
}

.edit-machine-com .machine-setting {
  display: flex;
  flex-wrap: wrap;
}

.edit-machine-com .machine-setting {
  width: 100%;
}

.edit-machine-com .machine-setting select,
.edit-machine-com .machine-setting input {
  width: 45%;
  margin-top: 15px;
}

.edit-machine-com .machine-setting input {
  margin-left: 20px;
}
</style>
